import { DiffMatchPatch } from './diff-match-patch';
import type { DiffPostProcessor } from './postProcessing';

export type RawDiff = {
	type: -1 | 0 | 1;
	text: string;
	length: number;
};

export const createDiffs = (
	a: string,
	b: string,
	postProcessors: DiffPostProcessor[] = [],
): RawDiff[] => {
	const diff = DiffMatchPatch.diff_linesToWords_(a, b);
	const diffs = DiffMatchPatch.diff_main(diff.chars1, diff.chars2, false);
	DiffMatchPatch.diff_charsToLines_(diffs, diff.lineArray);

	const normalized = diffs.map((diff: { [0]: -1 | 0 | 1; [1]: string }) => ({
		type: diff[0],
		text: diff[1],
		length: diff[1].length,
	}));

	return postProcessors.reduce((diffs, proc) => proc(diffs), normalized);
};
